module.exports = __webpack_public_path__ + "static/media/microphone-alt-slash.3df0e1e1.svg";